//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import ngSanitize from "angular-sanitize";

//services

//components
import promoSheetManager from "emun.promotion/promo-sheet/promo-sheet-manager";

export const dependencies = [dropdown, collapse, tabs, ngSanitize];

export const modules = {
  // modals,
};

//states
import states from "emun.promotion/promo-sheet/promo-sheets.states";

export const services = {};

export const components = {
  promoSheetManager,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
